import * as itemsActions from 'App/modules/items/items'
import * as categoriesActions from 'App/modules/categories'
import * as positioningActions from 'App/modules/positioning'
import update from 'immutability-helper'
import { SET_ACTIVE_TAB } from './actionTypes'
import { mergeArraysWithoutDuplicates } from 'shared/helper'
import { getFilterValue } from 'shared/helpers/FiltersHelper'
import { uploadFile } from 'App/services/FileUploadService'
import { ITEM_TYPE_FILTERS } from 'App/modules/items/constants'
import { ITEM_SOURCES } from 'shared/constants'
import get from 'lodash/get'
import pick from 'lodash/pick'
import without from 'lodash/without'
import each from 'lodash/each'
import filter from 'lodash/filter'
import omit from 'lodash/omit'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'

// items
const FETCH_FIRST_PAGE_SUCCESS = 'content/FETCH_FIRST_PAGE_SUCCESS'
const FETCH_NEXT_PAGE_SUCCESS = 'content/FETCH_NEXT_PAGE_SUCCESS'
const CREATE_FILE_ITEMS = 'content/CREATE_FILE_ITEMS'
const CREATE_FILE_ITEM_SUCCESS = 'content/CREATE_FILE_ITEM_SUCCESS'
export const DELETE_ITEM = 'content/DELETE_ITEM'
export const CHANGED_ACTIVE_FILTER = 'content/CHANGED_ACTIVE_FILTER'
export const CHANGED_SEARCH_QUERY = 'content/CHANGED_SEARCH_QUERY'
export const REMOVE_FILTERS = 'content/REMOVE_FILTERS'
export const CHANGE_SELECTED_CATEGORY = 'content/CHANGE_SELECTED_CATEGORY'
export const UPDATE_ITEM_STATUS_SUCCESS = 'content/UPDATE_ITEM_STATUS_SUCCESS'
export const UPDATE_SELECTED_CATEGORY_ITEMS = 'content/UPDATE_SELECTED_CATEGORY_ITEMS'

export const HOME_CATEGORY_ID = 'all'

export const FILTERS = {
  type: {
    is_multi_choice: true,
    multiple_label: '# Types',
    values: ITEM_TYPE_FILTERS
  },
  assignment: {
    is_multi_choice: false,
    values: [
      { id: 'all', label: 'All Category Assignment', default: true, is_all: true },
      { id: 'assigned', label: 'Assigned' },
      { id: 'unassigned', label: 'Unassigned' }
    ]
  },
  status: {
    is_multi_choice: true,
    multiple_label: '# Statuses',
    values: [
      { id: 'all', label: 'All Statuses', is_all: true },
      { id: 'online', label: 'Online', default: true },
      { id: 'offline', label: 'Offline' },
      { id: 'scheduled', label: 'Scheduled' },
      { id: 'expiring', label: 'Expiring' },
      { id: 'draft', label: 'Draft' }
    ]
  }
}
export const DEFAULT_FILTERS = {
  type: ['all'],
  assignment: ['all'],
  status: ['all'],
  search: ''
}

// items
export function fetchItems(boardId, { activeFilters, selectedCategoryId, page, actionType }) {
  return (dispatch) => {
    return itemsActions.fetchItems(boardId, {
      activeFilters: {
        ...activeFilters,
        category: selectedCategoryId
      },
      page
    })(dispatch)
      .then((items) => {
        dispatch({
          type: actionType,
          boardId,
          ...items
        })
      })
  }
}

export function fetchFirstPage(boardId, { activeFilters, selectedCategoryId }) {
  return function(dispatch, getState) {
    fetchItems(boardId, {
      activeFilters,
      selectedCategoryId,
      page: 1,
      actionType: FETCH_FIRST_PAGE_SUCCESS
    })(dispatch, getState)
  }
}

export function fetchNextPage(boardId, { activeFilters, selectedCategoryId, page }) {
  return function(dispatch, getState) {
    fetchItems(boardId, {
      activeFilters,
      selectedCategoryId,
      page,
      actionType: FETCH_NEXT_PAGE_SUCCESS
    })(dispatch, getState)
  }
}

export function createItem(params) {
  return (dispatch, getState) => {
    return itemsActions.createItem(params)(dispatch, getState)
  }
}

export function updateFile(boardId, item) {
  return function(dispatch, getState) {
    return updateItem(boardId, {
      ...item,
      file_name: item.file.name,
      file_id: item.file_id
    })(dispatch, getState)
      .then(item => itemsActions.fetchItemUntilImagePresent(item)(dispatch))
  }
}

export function uploadAndUpdateFile(boardId, item) {
  return function(dispatch, getState) {
    const uploadPromise = new Promise((resolve) => {
      return resolve(!get(item, 'file.lastModified')
        ? item
        : uploadFile(item.file)
      )
    })

    return uploadPromise.then(result => {
      return updateFile(boardId, {
        ...item,
        file_id: result.file_id,
        storage_provider_id: result.storage_provider_id,
        file_meta: result.file_meta
      })(dispatch, getState)
    })
  }
}

export function updateItem(boardId, item) {
  return function(dispatch, getState) {
    const previousItem = getState().items.data[item.board_id][item.id]
    const selectedCategoryId = getState().boardView[boardId].content.selectedCategoryId
    const itemVisibility = { ...item.item_visibility }
    const itemParams = omit(item, ['item_visibility'])

    return itemsActions.updateItem(itemParams)(dispatch, getState)
      .then(item => {
        if (selectedCategoryId !== HOME_CATEGORY_ID &&
          !item.categories_ids.includes(selectedCategoryId)) {
          dispatch({
            type: UPDATE_SELECTED_CATEGORY_ITEMS,
            boardId,
            item
          })
        }

        if (!isEqual(itemVisibility, previousItem.item_visibility)) {
          updateItemStatus(boardId, item, itemVisibility)(dispatch, getState)
        }

        return item
      })
  }
}

export function deleteItem(boardId, { itemId }) {
  return function(dispatch, getState) {
    dispatch({
      type: DELETE_ITEM,
      boardId,
      itemId
    })

    return itemsActions.deleteItem(boardId, itemId)(dispatch, getState)
  }
}

export function updateItemStatus(boardId, item, itemVisibility) {
  return (dispatch, getState) => {
    return itemsActions.updateItemStatus(item, itemVisibility)(dispatch, getState)
      .then(data => {
        dispatch(
          {
            type: UPDATE_ITEM_STATUS_SUCCESS,
            boardId,
            trackingParams: {
              item_id: item.id,
              status: itemVisibility.status
            }
          }
        )
      })
  }
}

export function createFileItems(params) {
  return (dispatch) => {
    dispatch({
      type: CREATE_FILE_ITEMS,
      boardId: params.board_id,
      fileNames: params.files.map((f) => ({ title: f.name, source: ITEM_SOURCES.file }))
    })

    if (isEmpty(params.captcha)) {
      // bypass captcha flow
      createFileItemsAction(params)(dispatch)
    } else {
      // The captcha token is valid for 2 minutes (can't be configured). If it will take more than 2 minutes to send the request with files, the captcha will be invalid.
      // Thus we persist the captcha in the backend for few minutes, and then perform all requests with the guid associated with this captcha
      const captchaGuid = itemsActions.getCaptchaGuid(params.board_id, params.captcha)
      return captchaGuid.then(response => {
        if (response && response.guid) {
          params.captcha_guid = response.guid
          delete params.captcha
        }
        createFileItemsAction(params)(dispatch)
      })
    }
  }
}

function createFileItemsAction(params) {
  return (dispatch) => {
    const itemPromises = itemsActions.createFileItems(params)(dispatch)
    return each(itemPromises, itemPromise => {
      return itemPromise.then(item => {
        dispatch({
          type: CREATE_FILE_ITEM_SUCCESS,
          processingFileName: item.processingFileName,
          boardId: item.board_id,
          item
        })

        return item
      })
        .then(item => itemsActions.fetchItemUntilImagePresent(item)(dispatch))
    })
  }
}

export function changeItemPosition({
  droppedItem,
  items,
  targetId,
  boardId,
  itemIds,
  selectedCategoryId,
  dropDirection
}) {
  return dispatch => {
    return itemsActions.changeItemPosition({
      droppedItem,
      targetId,
      items,
      boardId,
      itemIds,
      selectedCategoryId,
      dropDirection
    })(dispatch)
  }
}

// filters
export function setActiveFilter({ boardId, filter, selected }) {
  return function(dispatch) {
    dispatch({
      type: CHANGED_ACTIVE_FILTER,
      boardId,
      filter,
      selected,
      trackingParams: {
        filter,
        selected: selected.label
      }
    })
  }
}

export function setSearchQuery(boardId, query) {
  return function(dispatch) {
    dispatch({
      type: CHANGED_SEARCH_QUERY,
      boardId,
      query,
      trackingParams: { boardId, query }
    })
  }
}

export function removeFilters(boardId) {
  return function(dispatch) {
    dispatch({
      type: REMOVE_FILTERS,
      boardId
    })
  }
}
// categories
export function setSelectedCategory(boardId, categoryId) {
  return function(dispatch) {
    dispatch({
      type: CHANGE_SELECTED_CATEGORY,
      boardId,
      categoryId,
      trackingParams: {
        board_id: boardId,
        category_id: categoryId
      }
    })
  }
}

export function fetchCategories(boardId, options = {}) {
  return dispatch => {
    return categoriesActions.fetchCategories(boardId, options)(dispatch)
  }
}

export function createCategory(boardId, params) {
  return dispatch => {
    return categoriesActions.createCategory(boardId, params)(dispatch)
  }
}

export function updateCategory(category) {
  return dispatch => {
    return categoriesActions.updateCategory(category)(dispatch)
  }
}

export function removeCategory(category) {
  return function (dispatch, getState) {
    setSelectedCategoryAfterRemoveCategory(category.board_id, category)(dispatch, getState)
    return categoriesActions.removeCategory(category.board_id, category)(dispatch)
  }
}

export function createSubcategory(boardId, params) {
  return (dispatch, getState) => {
    return categoriesActions.createSubcategory(boardId, params)(dispatch, getState)
  }
}

export function removeSubcategory(subcategory) {
  return (dispatch, getState) => {
    setSelectedCategoryAfterRemoveCategory(subcategory.board_id, subcategory)(dispatch, getState)
    return categoriesActions.removeSubcategory(subcategory)(dispatch, getState)
  }
}

function setSelectedCategoryAfterRemoveCategory(boardId, category) {
  return (dispatch, getState) => {
    const selectedCategoryId = getState().boardView[boardId].content.selectedCategoryId
    if (category.subcategories_ids.indexOf(selectedCategoryId) > -1) {
      setSelectedCategory(boardId, HOME_CATEGORY_ID)(dispatch, getState)
    } else if (selectedCategoryId === category.id) {
      setSelectedCategory(boardId, HOME_CATEGORY_ID)(dispatch, getState)
    }
  }
}

export function unAssignItemFromCategory(boardId, categoryId, itemId) {
  return dispatch => {
    return categoriesActions.unAssignItemFromCategory(boardId, categoryId, itemId)(dispatch)
  }
}

export function addItemToCategory(boardId, categoryId, itemId) {
  return dispatch => {
    return categoriesActions.addItemToCategory(boardId, categoryId, itemId)(dispatch)
  }
}

export function changeCategoryPosition({
  droppedCategory,
  targetId,
  dropDirection,
  categories,
  categoriesIds
}) {
  return dispatch => {
    return categoriesActions.changeCategoryPosition({
      droppedCategory,
      targetId,
      dropDirection,
      categories,
      categoriesIds
    })(dispatch)
  }
}

export function updateArticleItem(itemId, boardId, params) {
  return itemsActions.updateArticleItem(itemId, boardId, params)
}

const initialFilterState = {
  isLoading: false,
  isSearching: false,
  itemIds: [],
  selectedItems: [],
  processingItems: [],
  activeFilters: DEFAULT_FILTERS,
  page: 1,
  totalPages: 1,
  perPage: 0,
  itemsCount: 0
}

const initialState = {
  ...initialFilterState,
  categoriesIds: [],
  selectedCategoryId: HOME_CATEGORY_ID,
  shouldFetchItems: false,
  actionPermissions: {
    boxSync: true
  }
}

export default function content(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeFilters: DEFAULT_FILTERS
      }
    case itemsActions.FETCH_ITEMS:
      return {
        ...state,
        isLoading: true,
        shouldFetchItems: false
      }
    case positioningActions.CHANGE_ITEM_POSITION:
      return {
        ...state,
        itemIds: action.itemIds
      }
    case FETCH_FIRST_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSearching: false,
        page: action.current_page,
        totalPages: action.total_pages,
        itemsCount: action.items_count,
        perPage: action.per_page,
        itemIds: action.item_ids
      }
    case FETCH_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSearching: false,
        page: action.current_page,
        totalPages: action.total_pages,
        perPage: action.per_page,
        itemsCount: action.items_count,
        itemIds: mergeArraysWithoutDuplicates(
          state.itemIds,
          action.item_ids
        )
      }
    case itemsActions.CREATE_ITEM_SUCCESS:
    case itemsActions.COPY_ITEM_SUCCESS:
    case itemsActions.IMPORT_CONTENT_ITEM_SUCCESS:
      return {
        ...state,
        activeFilters: DEFAULT_FILTERS,
        itemsCount: state.itemsCount + 1,
        itemIds: [action.item.id, ...state.itemIds]
      }
    case UPDATE_SELECTED_CATEGORY_ITEMS:
      return {
        ...state,
        itemsCount: state.itemsCount - 1,
        itemIds: without(state.itemIds, action.item.id)
      }
    case CREATE_FILE_ITEMS:
      return {
        ...state,
        processingItems: [...state.processingItems, ...action.fileNames]
      }
    case CREATE_FILE_ITEM_SUCCESS: {
      const processingItems = filter(
        state.processingItems,
        (pi) => pi.title !== action.processingFileName
      )
      return {
        ...state,
        activeFilters: DEFAULT_FILTERS,
        processingItems,
        itemsCount: state.itemsCount + 1,
        itemIds: [action.item.id, ...state.itemIds]
      }
    }
    case categoriesActions.UN_ASSIGN_ITEM_FROM_CATEGORY:
    case DELETE_ITEM:
      return {
        ...state,
        itemsCount: state.itemsCount - 1,
        itemIds: without(state.itemIds, action.itemId)
      }
    // filters
    case CHANGED_ACTIVE_FILTER: {
      const filter = pick(FILTERS, action.filter)[action.filter]
      const filterState = state.activeFilters[action.filter]
      return {
        ...state,
        ...initialFilterState,
        activeFilters: {
          ...state.activeFilters,
          [action.filter]: getFilterValue(filter, filterState, action.selected)
        }
      }
    }
    case CHANGED_SEARCH_QUERY:
      return {
        ...state,
        isSearching: true,
        activeFilters: {
          ...state.activeFilters,
          search: action.query
        }
      }
    case REMOVE_FILTERS:
      return {
        ...state,
        ...initialFilterState
      }
    case UPDATE_ITEM_STATUS_SUCCESS:
      return {
        ...state,
        ...initialFilterState,
        activeFilters: { ...state.activeFilters },
        shouldFetchItems: true
      }
    // categories
    case CHANGE_SELECTED_CATEGORY: {
      return {
        ...state,
        ...initialFilterState,
        selectedCategoryId: action.categoryId,
        shouldFetchItems: true
      }
    }
    case categoriesActions.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesIds: action.categoriesIds
      }
    case categoriesActions.CREATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        categoriesIds: update(state.categoriesIds, { $push: [action.categoryId] })
      }
    }
    case categoriesActions.CREATE_SUBCATEGORY_SUCCESS: {
      if (state.selectedCategoryId === action.parentCategoryId) {
        return {
          ...state,
          selectedCategoryId: action.subcategory.id
        }
      } else {
        return state
      }
    }
    case categoriesActions.REMOVE_CATEGORY: {
      const index = state.categoriesIds.indexOf(action.category.id)
      return {
        ...state,
        categoriesIds: update(state.categoriesIds, { $splice: [[index, 1]] })
      }
    }
    case positioningActions.CHANGE_CATEGORY_POSITION:
      return {
        ...state,
        categoriesIds: action.categoriesIds
      }
    default:
      return state
  }
}
